/* Sticky mobile ATC for the "5 Reasons Your Bladder Will Thank You After 40" LP.
   Ported from sections/lp-uro-vulnerable-v2.liquid (same bar, same behavior):
   collapsed pill -> expands to a 3-Month Journey / Single Bottle radio pair ->
   /cart/add.js (forwarding the subscription selling_plan) -> straight to checkout.

   Lives in an asset rather than an inline <script> because admin theme-editor
   roundtrips strip raw <script> tags out of section markup (see CLAUDE.md). */
(function () {
  'use strict';

  function init() {
    /* Shoplift/A-B defense: a template double-render leaves a second bar whose
       handlers never bind (getElementById returns the first). Keep the first,
       remove any duplicates so a dead-looking bar can never ship an arm. */
    Array.prototype.slice.call(document.querySelectorAll('[data-cro="sticky-atc"]'), 1)
      .forEach(function (dup) { try { dup.remove(); } catch (e) {} });
    var sticky = document.getElementById('r5m-sticky');
    if (!sticky) return;

    // Selectors are configurable so non-r5m pages can reuse this bar (see
    // snippets/lp-sticky-atc.liquid). Defaults are the r5m fleet's anchors.
    var heroSelector = sticky.getAttribute('data-hero-selector') || '.r5m__hero';
    var buySelector = sticky.getAttribute('data-buy-selector') || '#r5m-buy';
    var hero = document.querySelector(heroSelector);
    var buyBox = document.querySelector(buySelector);
    var trigger = sticky.querySelector('[data-sticky-trigger]');
    var panel = sticky.querySelector('[data-sticky-panel]');
    var atc = sticky.querySelector('[data-sticky-atc]');
    var status = sticky.querySelector('[data-sticky-status]');

    /* ─── Show after the hero scrolls away, hide over the buy box ─── */
    var heroVisible = true;
    var buyVisible = false;
    var update = function () {
      var shouldShow = !heroVisible && !buyVisible;
      sticky.classList.toggle('r5m__sticky--visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    };

    if ('IntersectionObserver' in window) {
      if (hero) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { heroVisible = entry.isIntersecting; });
          update();
        }, { rootMargin: '-50px 0px 0px 0px' }).observe(hero);
      } else {
        heroVisible = false;
        update();
      }
      if (buyBox) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { buyVisible = entry.isIntersecting; });
          update();
        }, { threshold: 0.1 }).observe(buyBox);
      }
    } else {
      /* No IntersectionObserver: show it rather than hiding the CTA entirely. */
      heroVisible = false;
      update();
    }

    /* ─── Expand / collapse ─── */
    var setExpanded = function (expanded) {
      if (!panel || !trigger) return;
      sticky.classList.toggle('r5m__sticky--expanded', expanded);
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      panel.hidden = !expanded;
      if (!expanded && status) status.textContent = '';
    };

    if (trigger) trigger.addEventListener('click', function () { setExpanded(true); });

    /* P4 one-offer variant: the escape link buys the single bottle. It selects
       the last option (the one-time single in every variant's markup), lets the
       change handler sync state, then fires the normal ATC path. */
    var escapeBtn = sticky.querySelector('[data-sticky-escape]');
    if (escapeBtn) escapeBtn.addEventListener('click', function () {
      var opts = sticky.querySelectorAll('input[name="r5m-sticky-option"]');
      var single = opts[opts.length - 1];
      if (!single) return;
      single.checked = true;
      single.dispatchEvent(new Event('change', { bubbles: true }));
      if (atc) atc.click();
    });

    var onOptionChange = function (input) {
      Array.prototype.forEach.call(
        sticky.querySelectorAll('.r5m__sticky-option'),
        function (option) { option.classList.toggle('is-selected', option.contains(input)); }
      );
      // P1/C: the button mirrors the chosen option. Two-span markup carries a
      // main line (per-bottle continuity with the collapsed trigger) and a
      // charge/cadence subline; data-btn-* is set by Liquid on each label.
      // Older single-span markup falls back to the plain price restatement.
      var selected = input.closest('.r5m__sticky-option');
      if (!atc || !selected) return;
      var main = atc.querySelector('[data-atc-main]');
      var sub = atc.querySelector('[data-atc-sub]');
      if (main && selected.dataset.btnMain) {
        main.textContent = selected.dataset.btnMain;
        if (sub) {
          sub.textContent = selected.dataset.btnSub || '';
          sub.hidden = !selected.dataset.btnSub;
        }
      } else if (selected.dataset.price) {
        atc.textContent = 'Add to cart \u00B7 ' + selected.dataset.price;
      }
    };
    var bindOptions = function (root) {
      Array.prototype.forEach.call(
        root.querySelectorAll('input[name="r5m-sticky-option"]'),
        function (input) {
          input.addEventListener('change', function () { onOptionChange(input); });
        }
      );
    };
    bindOptions(sticky);

    /* ─── p5 "all-in price" arm (live Shoplift test sticky-allin-price-1) ───
       API-type, Automatic-assignment test: arm A = p6 (hypothesis id on
       data-satc-control-hypothesis, Theme settings > LP sticky bar A/B >
       satc_p6_hypothesis_id), arm B = p5 (data-satc-hypothesis,
       satc_p5_hypothesis_id). p5 is now the DEFAULT for anyone NOT enrolled:
         A active                       -> p6 (stay).
         B active                       -> p5 (swap).
         not enrolled / no Shoplift /
         timeout / error / blank IDs    -> p6 (the not-enrolled default since 2026-10-13).
       Code-activated, no template duplication: when the bar rendered as p6
       and the product qualifies, the snippet also ships the p5 rows inert in
       <template data-satc-p5>. Here we decide the arm and, for p5, swap the
       rows in (the ATC button and status nodes are kept, so their handlers
       stay bound).
         ?satc=p5                       force treatment (QA), arm 'B'.
         ?satc=control | ?satc=p6 | the
         legacy ?satc=p1                force control (QA), arm 'A'. All
                                         three are equivalent and normalize to
                                         'control' in sessionStorage.
         ?satc=off                      clears the forced arm and returns to
                                         the normal (Shoplift-driven) decision.
         Forced arms are kept in sessionStorage for the session; a forced
         visitor never calls Shoplift, so testers don't enrol themselves.
       The arm locks the first time she opens the bar: if neither hypothesis
       has answered by then, lock to p6 (the not-enrolled default since the p5 test ended 2026-10-13) rather than
       block her on a slow network call. */
    var p5Tpl = document.querySelector('template[data-satc-p5]');
    var armLocked = false;
    /* Read at fire time, not load time: the p5 arm can swap in after init.
       Defined here (ahead of settleArm, which is called synchronously below
       on init) rather than down by stampVariant, so it exists before its
       first caller runs. */
    var currentVariant = function () {
      return (sticky.getAttribute && sticky.getAttribute('data-satc-variant')) || 'p6';
    };
    var currentArm = function () {
      return (sticky.getAttribute && sticky.getAttribute('data-satc-arm')) || 'none';
    };
    var swapToP5 = function () {
      if (!p5Tpl || !p5Tpl.content || !panel || !atc) return false;
      var frag = p5Tpl.content.cloneNode(true);
      var newOpts = frag.querySelector('.r5m__sticky-options');
      var oldOpts = panel.querySelector('.r5m__sticky-options');
      if (!newOpts || !oldOpts) return false;
      var after = frag.querySelector('[data-satc-p5-after-atc]');
      var style = frag.querySelector('style');
      /* p6 already renders its own <p class="r5m__sticky-guarantee"> after
         the ATC button; drop it before inserting p5's, or the treatment arm
         shows the reassurance line twice. */
      var oldGuarantee = panel.querySelector('.r5m__sticky-guarantee');
      if (oldGuarantee) oldGuarantee.parentNode.removeChild(oldGuarantee);
      oldOpts.parentNode.replaceChild(newOpts, oldOpts);
      if (after) atc.parentNode.insertBefore(after, atc.nextSibling);
      if (style) panel.insertBefore(style, panel.firstChild);
      sticky.setAttribute('data-satc-variant', 'p5');
      bindOptions(newOpts);
      var checked = newOpts.querySelector('input[name="r5m-sticky-option"]:checked');
      if (checked) onOptionChange(checked);
      return true;
    };
    /* variant: 'p5' swaps the rows in; anything else (e.g. 'control') leaves
       the server-rendered p6 bar as-is. satcArm: 'A' (p6/control), 'B'
       (p5/treatment), or 'none' (not enrolled / unresolved / unavailable) -
       stamped onto the cart alongside satc_variant so post-purchase analysis
       can tell a real B enrollment apart from the not-enrolled default that
       also happens to render p5. */
    var settleArm = function (variant, satcArm, source, report) {
      if (armLocked) return;
      armLocked = true;
      var applied = variant === 'p5' && swapToP5();
      sticky.setAttribute('data-satc-arm-source', source);
      sticky.setAttribute('data-satc-arm', satcArm);
      if (report && typeof window.fireEvent === 'function') {
        window.fireEvent('satc_arm', { satc_variant: applied ? 'p5' : currentVariant(), satc_arm: satcArm, source: source });
      }
    };
    if (p5Tpl && panel && atc) {
      /* If neither hypothesis has answered by the time she opens the bar,
         lock to the not-enrolled default (p5) rather than block her on a
         slow Shoplift response. No-op once settleArm has already fired. */
      if (trigger) trigger.addEventListener('click', function () { settleArm('control', 'none', 'expanded_first', true); });
      var forcedArm = null;
      try {
        var q = new URLSearchParams(window.location.search).get('satc');
        if (q === 'p5') {
          forcedArm = 'p5';
          try { sessionStorage.setItem('satcArm', 'p5'); } catch (e) {}
        } else if (q === 'control' || q === 'p6' || q === 'p1') {
          forcedArm = 'control';
          try { sessionStorage.setItem('satcArm', 'control'); } catch (e) {}
        } else if (q === 'off') {
          try { sessionStorage.removeItem('satcArm'); } catch (e) {}
        }
        if (!forcedArm) {
          var kept = null;
          try { kept = sessionStorage.getItem('satcArm'); } catch (e) {}
          if (kept === 'p5' || kept === 'control' || kept === 'p1') forcedArm = kept === 'p1' ? 'control' : kept;
        }
      } catch (e) {}
      var hypA = (p5Tpl.getAttribute('data-satc-control-hypothesis') || '').trim();
      var hypB = (p5Tpl.getAttribute('data-satc-hypothesis') || '').trim();
      var isMobile = true;
      try { isMobile = window.matchMedia('(max-width: 749px)').matches; } catch (e) {}
      if (forcedArm) {
        settleArm(forcedArm === 'p5' ? 'p5' : 'control', forcedArm === 'p5' ? 'B' : 'A', 'override', true);
      } else if (!isMobile) {
        /* Desktop: the bar is display:none via CSS regardless of arm. Settle
           quietly (no event) so nothing is left unresolved, but don't touch
           the DOM or bother Shoplift. */
        settleArm('control', 'none', 'desktop', false);
      } else if (!hypA && !hypB) {
        /* Definitively unavailable: no test configured for this page. */
        settleArm('control', 'none', 'no_hypothesis', true);
      } else {
        var askShoplift = function () {
          try {
            var shoplift = window.shoplift;
            if (!shoplift || typeof shoplift.isHypothesisActive !== 'function') throw new Error('no shoplift');
            Promise.all([
              hypA ? Promise.resolve(shoplift.isHypothesisActive(hypA)) : Promise.resolve(false),
              hypB ? Promise.resolve(shoplift.isHypothesisActive(hypB)) : Promise.resolve(false)
            ]).then(
              function (results) {
                var aActive = results[0] === true;
                var bActive = results[1] === true;
                if (aActive) settleArm('control', 'A', 'shoplift', true);
                else if (bActive) settleArm('p5', 'B', 'shoplift', true);
                else settleArm('control', 'none', 'shoplift', true);
              },
              function () { settleArm('control', 'none', 'shoplift_error', true); }
            );
          } catch (e) { settleArm('control', 'none', 'shoplift_error', true); }
        };
        if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
          askShoplift();
        } else {
          /* The Shoplift embed bootstraps its SDK asynchronously. Poll; the bar
             is hidden until the hero scrolls away, so a late answer is fine. */
          var waited = 0;
          var poll = setInterval(function () {
            waited += 100;
            if (armLocked) { clearInterval(poll); return; }
            if (window.shoplift && typeof window.shoplift.isHypothesisActive === 'function') {
              clearInterval(poll);
              askShoplift();
            } else if (waited >= 10000) {
              clearInterval(poll);
              settleArm('control', 'none', 'no_shoplift', true);
            }
          }, 100);
        }
      }
    }

    document.addEventListener('pointerdown', function (event) {
      if (sticky.classList.contains('r5m__sticky--expanded') && !sticky.contains(event.target)) {
        setExpanded(false);
      }
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') setExpanded(false);
    });

    /* ─── Add to cart -> checkout ─── */
    if (!atc) return;

    /* Adversarial-review fixes 2026-08-31: sessionStorage can throw in private
       browsing / embedded webviews; a throw inside the post-add .then used to
       convert a SUCCESSFUL add into an error toast and invite a double add. */
    var safeSession = {
      get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
    };
    /* Per-arm instrumentation: the bar renders its resolved variant; every
       event this file emits carries it, and after a successful add the arm is
       stamped onto the cart as an attribute so post-purchase guardrails
       (refunds, charge-2 survival) can be cut by arm on the ORDER. */
    var stampVariant = function () {
      try {
        var fd = new FormData();
        fd.append('attributes[satc_variant]', currentVariant());
        fd.append('attributes[satc_arm]', currentArm());
        /* buy_surface: shared with the LP offer cards (snippets/lp-hbrr-offer)
           and the UTC sticky, so orders can be cut by the surface that started them. */
        fd.append('attributes[buy_surface]', 'sticky');
        /* Returns the request so the sticky ATC can wait for it: navigating
           to /checkout while it was in flight dropped the attribute (seen in
           p5 QA 2026-09-25, both arms). keepalive covers other callers. */
        return fetch('/cart/update.js', { method: 'POST', body: fd, keepalive: true, headers: { 'Accept': 'application/json' } }).catch(function () {});
      } catch (e) { return null; }
    };
    /* Run fn once the stamp settles, capped so she is never held up. */
    var afterStamp = function (stamp, fn) {
      var done = false;
      var once = function () { if (!done) { done = true; fn(); } };
      if (stamp && typeof stamp.then === 'function') {
        stamp.then(once, once);
        setTimeout(once, 1500);
      } else {
        once();
      }
    };
    window.lpStampVariant = stampVariant;

    /* Bump prefetch: read the cart total once at load so the intercept decision
       at click time is pure arithmetic (no round-trip between the add and the
       modal). null = unknown (fetch failed or still in flight); the click
       handler then falls back to the Liquid-rendered defaults. */
    var bumpEl = document.querySelector('[data-bump-modal]');
    var baseCartTotal = null;
    /* Shared M1 intercept. Callers (this sticky bar, the buy box in custom.js)
       invoke it after a successful ONE-TIME add. Returns true when the modal
       was shown and now owns navigation; false means the caller proceeds with
       its own default (checkout, cart drawer). proceed() is what "decline"
       resolves to, so each surface keeps its native flow. Inert wherever the
       page has no [data-bump-modal] (only pages given a bump_discount_code). */
    window.lpBumpMaybeShow = function (variantId, addedCents, proceed) {
      var bump = bumpEl;
      if (!bump) return false;
      if (bump.getAttribute('data-bump-variant') !== String(variantId)) return false;
      if (sessionStorage.getItem('lpBumpShown')) return false;
      var threshold = parseInt(bump.getAttribute('data-bump-threshold'), 10) || 5000;
      var secondCents = parseInt(bump.getAttribute('data-bump-second'), 10) || 0;
      if (addedCents === null || addedCents === undefined) {
        addedCents = parseInt(bump.getAttribute('data-bump-single'), 10) || 0;
      }
      var cartTotal = baseCartTotal === null ? null : baseCartTotal + addedCents;
      /* Shipping already free: premise false, skip WITHOUT burning the flag. */
      if (cartTotal !== null && cartTotal >= threshold) return false;
      safeSession.set('lpBumpShown', '1');
      if (cartTotal !== null) {
        var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
        var gapEl = bump.querySelector('[data-bump-gap]');
        if (gapEl) gapEl.textContent = money(threshold - cartTotal);
        var meter = bump.querySelector('[data-bump-meter]');
        if (meter) meter.style.width = Math.min(100, Math.round(cartTotal * 100 / threshold)) + '%';
        var totalLine = bump.querySelector('[data-bump-total-line]');
        if (totalLine && secondCents) totalLine.textContent = 'Order total ' + money(cartTotal + secondCents) + ' \u00b7 free shipping';
      }
      bump.hidden = false;
      if (typeof window.fireEvent === 'function') {
        window.fireEvent('bump_show', { variant_id: variantId, satc_variant: currentVariant() });
      }
      /* One answer per show: accept, decline and close all race to settle. */
      var settled = false;
      var settle = function () { if (settled) return false; settled = true; return true; };
      Array.prototype.forEach.call(bump.querySelectorAll('[data-bump-close]'), function (el) {
        el.addEventListener('click', function () {
          /* Close (X) or backdrop tap = keep the one bottle she chose and
             carry on with her surface's own flow, same as "No thanks".
             The old stay-on-page dismiss stranded her with a bottle in the
             cart and no cue, and because the bump shows once per session,
             a second "Try One Bottle" tap added another full-price bottle
             and sent her to checkout with 2 at full price (2026-10-22,
             docs/analysis/hb-chin-hair-6-signs-2026-10). Still logged as
             bump_dismiss so close vs decline stays measurable. */
          if (!settle()) return;
          bump.hidden = true;
          if (typeof window.fireEvent === 'function') {
            window.fireEvent('bump_dismiss', { variant_id: variantId, satc_variant: currentVariant() });
          }
          proceed();
        }, { once: true });
      });
      var bumpStatus = bump.querySelector('[data-bump-status]');
      var accept = bump.querySelector('[data-bump-accept]');
      if (accept) accept.addEventListener('click', function () {
        if (!settle()) return;
        accept.disabled = true;
        if (bumpStatus) bumpStatus.textContent = 'Adding your second bottle...';
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
          .then(function (r) { if (!r.ok) throw new Error('bump add failed'); return r.json(); })
          .then(function () {
            if (typeof window.fireEvent === 'function') {
              window.fireEvent('bump_accept', { variant_id: variantId, satc_variant: currentVariant() });
            }
            if (bumpStatus) bumpStatus.textContent = 'Applying your discount...';
            window.location.href = '/discount/' + encodeURIComponent(bump.getAttribute('data-bump-code')) + '?redirect=%2Fcheckout';
          })
          .catch(function () {
            /* The first bottle is already in the cart; never strand her. */
            window.location.href = '/checkout';
          });
      }, { once: true });
      Array.prototype.forEach.call(bump.querySelectorAll('[data-bump-decline]'), function (el) {
        el.addEventListener('click', function () {
          if (!settle()) return;
          if (typeof window.fireEvent === 'function') {
            window.fireEvent('bump_decline', { variant_id: variantId, satc_variant: currentVariant() });
          }
          bump.hidden = true;
          proceed();
        }, { once: true });
      });
      return true;
    };
    if (bumpEl) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { baseCartTotal = cart.total_price; })
        .catch(function () { baseCartTotal = null; });
      document.addEventListener('cart:modified', function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { baseCartTotal = cart.total_price; })
          .catch(function () {});
      });
    }
    atc.addEventListener('click', function () {
      var selected = sticky.querySelector('input[name="r5m-sticky-option"]:checked');
      if (!selected) return;

      var variantId = selected.value;
      var sellingPlan = selected.getAttribute('data-selling-plan');
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (sellingPlan) formData.append('selling_plan', sellingPlan);

      atc.disabled = true;
      if (status) status.textContent = 'Adding to cart...';

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Cart request failed');
          return response.json();
        })
        .then(function (addedItem) {
          /* window.fireEvent is not defined in this theme; guard it so a missing
             global doesn't throw and kill everything below. */
          if (typeof window.fireEvent === 'function') {
            window.fireEvent('add_to_cart', {
              variant_id: variantId,
              quantity: 1,
              purchase_type: sellingPlan ? 'subscription' : 'one_time',
              satc_variant: currentVariant()
            });
          }
          document.dispatchEvent(new Event('cart:modified'));
          var stamp = stampVariant();
          /* M1 intercept, shared logic: window.lpBumpMaybeShow decides and, when
             it shows, owns the modal's buttons. Returns true if it took over. */
          if (!sellingPlan && typeof window.lpBumpMaybeShow === 'function') {
            var addedCents = (addedItem && (addedItem.final_price || addedItem.price)) || null;
            var tookOver = window.lpBumpMaybeShow(String(variantId), addedCents, function () {
              if (status) status.textContent = 'Taking you to checkout...';
              window.location.href = '/checkout';
            });
            if (tookOver) {
              if (status) status.textContent = '';
              atc.disabled = false;
              return;
            }
          }
          if (status) status.textContent = 'Taking you to checkout...';
          afterStamp(stamp, function () { window.location.href = '/checkout'; });
        })
        .catch(function () {
          if (status) status.textContent = 'We could not add this option. Please try again.';
          atc.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
